import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, AlertTriangle } from 'lucide-react';
export function NotFound() {
  return <div className="w-full min-h-screen bg-white flex items-center justify-center px-4 py-16" data-id="element-536">
      <div className="max-w-2xl w-full" data-id="element-537">
        {/* Main 404 Card */}
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 20,
        duration: 0.3
      }} className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-brutal p-8 md:p-12 text-center" data-id="element-538">
          {/* Animated Icon */}
          <motion.div initial={{
          rotate: -10,
          scale: 0
        }} animate={{
          rotate: 0,
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 15,
          delay: 0.2
        }} className="inline-block mb-6" data-id="element-539">
            <div className="bg-purple border-brutal border-[#1A1A1A] rounded-none p-6" data-id="element-540">
              <AlertTriangle className="w-16 h-16 text-yellow" data-id="element-541" />
            </div>
          </motion.div>

          {/* 404 Text with staggered animation */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20,
          delay: 0.3
        }} data-id="element-542">
            <h1 className="font-display text-8xl md:text-9xl font-bold text-purple uppercase tracking-tight leading-none mb-4" data-id="element-543">
              404
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20,
          delay: 0.4
        }} data-id="element-544">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-purple uppercase tracking-tight mb-4" data-id="element-545">
              Página No Encontrada
            </h2>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 0.2
        }} className="text-lg text-[#1A1A1A] mb-8" data-id="element-546">
            La página que buscas no existe o ha sido movida.
          </motion.p>

          {/* Animated Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20,
          delay: 0.6
        }} data-id="element-547">
            <Link to="/stats" className="inline-flex items-center gap-2 bg-purple border-brutal border-yellow text-white font-display uppercase text-sm font-bold px-6 py-3 hover:bg-white hover:text-purple transition-all duration-100 hover:shadow-glow" data-id="element-548">
              <Home className="w-5 h-5" data-id="element-549" />
              <span data-id="element-550">Volver al Inicio</span>
            </Link>
          </motion.div>
        </motion.div>

        {/* Decorative Elements */}
        <div className="mt-8 flex justify-center gap-4" data-id="element-551">
          {[0, 1, 2].map(index => <motion.div key={index} initial={{
          scale: 0,
          rotate: -180
        }} animate={{
          scale: 1,
          rotate: 0
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 15,
          delay: 0.7 + index * 0.1
        }} className="w-4 h-4 bg-purple border-2 border-[#1A1A1A]" data-id="element-552" />)}
        </div>
      </div>
    </div>;
}